module.exports = __webpack_public_path__ + "static/media/flatbed.233d014b.webp";